import type { LatestPayload } from '../api/types';
import type { Snapshot } from '../lib/snapshot';
import { AGE_HEAD_LIVE, TICKER_HEADS, tickerFromApi, tickerFromSnapshot, type TickerModel } from '../lib/ticker';
import { ApiStateText } from './ApiStateText';

export interface TickerProps {
  latest: LatestPayload | null;
  snapshot: Snapshot | null;
}

/** Every symbol of /latest against its feed; the recorded snapshot when the worker is unreachable. */
export function Ticker({ latest, snapshot }: TickerProps) {
  const model: TickerModel | null = latest ? tickerFromApi(latest) : snapshot ? tickerFromSnapshot(snapshot) : null;
  return (
    <section className="section" id="ticker">
      <h2>Every pool against its feed</h2>
      <p className="table-intro" id="ticker-intro">{model ? model.intro : 'Waiting for the API to answer.'} Live API: <ApiStateText />.</p>
      <div className="table-scroll">
        <table className="basis ticker" id="ticker-table">
          <thead>
            <tr>
              <th>{TICKER_HEADS[0]}</th>
              <th className="num">{TICKER_HEADS[1]}</th>
              <th className="num">{TICKER_HEADS[2]}</th>
              <th className="num">{TICKER_HEADS[3]} (bps)</th>
              <th className="num">{TICKER_HEADS[4]} (bps)</th>
              <th className="num">{TICKER_HEADS[5]} (bps)</th>
              <th>{model ? model.ageHead : AGE_HEAD_LIVE}</th>
            </tr>
          </thead>
          <tbody>
            {model?.rows.map((r) => (
              <tr key={r.key}>
                <td>{r.sym}</td>
                <td className="num">{r.pool}</td>
                <td className="num">{r.feed}</td>
                <td className={`num ${r.gapClass}`}>{r.gap}</td>
                <td className="num">{r.poolFee}</td>
                <td className="num">{r.hookFee}</td>
                <td>{r.feedAge}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
